import GatsbyImage from 'gatsby-image'
import React, { FC, useMemo } from 'react'
import { Event } from '../../data/event'
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonial: FC<Event['testimonials']['quotes'][0]> = ({ quote, avatar, author, info_1, info_2 }) => (
  <div className="self-start mx-8 text-center">
    <svg className="mx-auto" width="45" height="34" viewBox="0 0 45 34" fill="none">
      <path d="M20.0342 21.756C20.1027 22.2956 20.137 22.7679 20.137 23.1726C20.137 23.5099 20.137 23.9484 20.137 24.4881C20.137 27.3214 19.2808 29.6151 17.5685 31.369C15.8562 33.123 13.5274 34 10.5822 34C7.22603 34 4.62329 32.8532 2.77397 30.5595C0.924657 28.2659 0 25.2976 0 21.6548C0 19.4286 0.342466 17.2361 1.0274 15.0774C1.71233 12.9186 2.67123 10.8948 3.90411 9.00595C5.20548 7.0496 6.78082 5.32936 8.63014 3.84524C10.4795 2.29365 12.5342 1.0119 14.7945 0L19.1096 3.84524C17.1918 5.19444 15.6849 6.74603 14.589 8.5C13.5616 10.254 13.0479 12.0079 13.0479 13.7619C13.0479 15.6508 13.6301 17.3373 14.7945 18.8214C16.0274 20.2381 17.774 21.2163 20.0342 21.756ZM44.8973 21.756C44.9658 22.2956 45 22.7679 45 23.1726C45 23.5099 45 23.9484 45 24.4881C45 27.3214 44.1438 29.6151 42.4315 31.369C40.7192 33.123 38.3904 34 35.4452 34C32.089 34 29.4863 32.8532 27.637 30.5595C25.7877 28.2659 24.863 25.2976 24.863 21.6548C24.863 19.4286 25.2055 17.2361 25.8904 15.0774C26.5753 12.9186 27.5342 10.8948 28.7671 9.00595C30.0685 7.0496 31.6438 5.32936 33.4931 3.84524C35.3425 2.29365 37.3973 1.0119 39.6575 0L43.9726 3.84524C42.0548 5.19444 40.5479 6.74603 39.4521 8.5C38.4247 10.254 37.911 12.0079 37.911 13.7619C37.911 15.6508 38.4931 17.3373 39.6575 18.8214C40.8904 20.2381 42.637 21.2163 44.8973 21.756Z" fill="#00FF99" />
    </svg>
    <p className="text-xl my-6 text-gray-700 leading-relaxed">{quote}</p>
    <GatsbyImage className="mx-auto rounded-full mb-4" fixed={avatar.childImageSharp.fixed} />
    <div className="font-bold text-xl mb-2">{author}</div>
    <div className="text-gray-500">{info_1}</div>
    <div className="text-gray-500">{info_2}</div>
  </div>
)

const ArrowLeft: FC<any> = ({ className, style, onClick }) => <button className={className} style={style} onClick={onClick}><svg width="18" height="27" viewBox="0 0 18 27" fill="none">
  <path d="M17.1148 27C16.9461 27 16.7073 26.8986 16.3981 26.6957L1.22248 16.0435C0.800937 15.7536 0.491803 15.4783 0.295082 15.2174C0.0983606 14.9275 0 14.5797 0 14.1739V12.8261C0 12.4203 0.0983606 12.0725 0.295082 11.7826C0.491803 11.4928 0.800937 11.2029 1.22248 10.913L16.3981 0.260869C16.7354 0.0869563 16.9742 0 17.1148 0C17.3677 0 17.5785 0.0869563 17.7471 0.260869C17.9157 0.405796 18 0.608695 18 0.869564V5.56522C18 5.97101 17.8876 6.30435 17.6628 6.56522C17.466 6.7971 17.185 7.02899 16.8197 7.26087L7.62998 13.4783L16.8197 19.7391C17.2131 19.971 17.5082 20.2029 17.7049 20.4348C17.9016 20.6667 18 20.9855 18 21.3913V26.087C18 26.3478 17.9157 26.5652 17.7471 26.7391C17.5785 26.913 17.3677 27 17.1148 27Z" fill="#C4C4C4" />
</svg></button>
const ArrowRight: FC<any> = ({ className, style, onClick }) => <button className={className} style={style} onClick={onClick}><svg width="18" height="27" viewBox="0 0 18 27" fill="none">
  <path d="M0.885244 0C1.05386 0 1.29274 0.10145 1.60187 0.304348L16.7775 10.9565C17.1991 11.2464 17.5082 11.5217 17.7049 11.7826C17.9016 12.0725 18 12.4203 18 12.8261V14.1739C18 14.5797 17.9016 14.9275 17.7049 15.2174C17.5082 15.5072 17.1991 15.7971 16.7775 16.087L1.60187 26.7391C1.26464 26.913 1.02576 27 0.885244 27C0.632317 27 0.421545 26.913 0.252926 26.7391C0.0843086 26.5942 0 26.3913 0 26.1304V21.4348C0 21.029 0.112411 20.6957 0.337234 20.4348C0.533957 20.2029 0.814987 19.971 1.18033 19.7391L10.37 13.5217L1.18033 7.26087C0.786884 7.02899 0.491802 6.7971 0.29508 6.56522C0.0983601 6.33333 0 6.01449 0 5.6087V0.913044C0 0.652174 0.0843086 0.434784 0.252926 0.26087C0.421545 0.0869579 0.632317 0 0.885244 0Z" fill="#C4C4C4" />
</svg></button>

const Testimonials = ({ quotes }: { quotes: Event['testimonials']['quotes'] }) => {
  const slides = useMemo(() => quotes.map((testimonial, i) => <Testimonial key={i} {...testimonial} />), [quotes])

  const slider_settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <ArrowRight />,
    prevArrow: <ArrowLeft />,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  };
  return (
    <>
      <Slider {...slider_settings}>{slides}</Slider>
    </>
  )
}

export default Testimonials
